"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _modal = require('redux/actions/modal');

var _modal_type = require('redux/actions/modal_type');

var _auth = require('redux/actions/auth');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    RegistrationSuccess: {
        displayName: 'RegistrationSuccess'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Registration/RegistrationSuccess/RegistrationSuccess.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var RegistrationSuccess = _wrapComponent('RegistrationSuccess')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        preload: state.auth.preload,
        settings: state.setting,
        user: state.auth.user,
        lang: state.lang
    };
}, { showModalAuth: _modal_type.showModalAuth, login: _auth.login, hide: _modal.hide }), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(RegistrationSuccess, _Component);

    function RegistrationSuccess() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegistrationSuccess);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationSuccess.__proto__ || (0, _getPrototypeOf2.default)(RegistrationSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.onShowAuth = function () {
            var _this$props = _this.props,
                formData = _this$props.formData,
                settings = _this$props.settings;

            var login = '';
            settings.additionalFieldSettings.find(function (item) {
                if (item.type_id == 1 && item.required_in_registration) {
                    login = formData.phone;
                    return true;
                } else if (item.type_id == 2 && item.required_in_registration) {
                    login = formData.email;
                    return true;
                }
            });

            _this.props.login({ login: login, password: formData.password, captcha: null, callback: _this._closeModal });
            //this.props.showModalAuth(this.props.lang);
        }, _this._closeModal = function () {
            _this.props.hide();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(RegistrationSuccess, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.onShowAuth();
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationSuccess', null, { folderName: "Registration/RegistrationSuccess" }),
                _props = this.props,
                preload = _props.preload,
                user = _props.user;


            return _react3.default.createElement(View, {
                preload: preload
            });
        }
    }]);
    return RegistrationSuccess;
}(_react2.Component), _class2.propTypes = {
    showModalAuth: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    setting: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp2)) || _class));

exports.default = RegistrationSuccess;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationSuccess/RegistrationSuccess.jsx
// module id = 1755
// module chunks = 0